// extracted by mini-css-extract-plugin
export default {"root":"AddToProjectButton_root__AyluV","circle":"AddToProjectButton_circle__yg-qy","plus":"AddToProjectButton_plus__twPAv","text":"AddToProjectButton_text__YhbLz"};